/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import actionIcon from '../../../../../assets/images/Fireboard/action.png';
import classes from './TileHeader.module.css';

const TileHeader = ({ check, showPopup }) => {
  return (
    <div className={classes.headerContainer}>
      <div className={classes.contentWrapper}>
        <span className={classes.text}>#{check?.checkNumber}</span>
      </div>
      <div className={classes.menuIconWrapper}>
        <img
          src={actionIcon}
          onClick={() => showPopup && showPopup('check-actions', check)}
          className={classes.menuIcon}
          alt='menu'
        />
      </div>
    </div>
  );
};

export default TileHeader;

TileHeader.propTypes = {
  check: PropTypes.object,
  showPopup: PropTypes.func,
};

TileHeader.defaultProps = {
  check: {},
  showPopup: () => { },
};
